const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

module.exports.reportData = {
  info: {
    campaignName: 'Jumanji: Welcome to the Jungle',
    influencerName: 'Callux',
    reportDate: new Date('2017-12-21'),
    hasLogo: true,
  },
  youtubeViews: 392582,
  youtubeEngagements: 27676,
  supportingActivity: [
    {
      platform: 'twitter',
      title: 'Did you guys catch me turning my girlfriend’s room into a #Jumanji inspired JUNGLE?',
      views: 151541,
      engagements: 3790,
      url: 'https://twitter.com/Callux/status/939938296024764417',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601400705-Screen_Shot_2017_12_14_at_12.00.48.png',
    },
    {
      platform: 'twitter',
      title: 'Another day, another successful prank / surprise 🙌🙌',
      views: 136358,
      engagements: 5605,
      url: 'https://twitter.com/Callux/status/934513227572137985',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513906550947-WhatsApp_Image_2017_12_22_at_00.42.51.jpeg',
    },
    {
      platform: 'twitter',
      title: 'Did you enjoy the video today?',
      views: 135691,
      engagements: 3371,
      url: 'https://twitter.com/Callux/status/939636502342066176',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513906574463-WhatsApp_Image_2017_12_22_at_00.42.51_1_.jpeg',
    },
    {
      platform: 'twitter',
      title: 'WHAT ABOUT a new video in 5 mins?',
      views: 108526,
      engagements: 2555,
      url: 'https://twitter.com/Callux/status/939569205317431296',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513906587579-WhatsApp_Image_2017_12_22_at_00.42.51_2_.jpeg',
    },
    {
      platform: 'twitter',
      title: 'NEW VIDEOOOO TRANSFORMING MY GIRLFRIEND\'S ROOM INTO A JUNGLE',
      views: 184573,
      engagements: 3915,
      url: 'https://twitter.com/Callux/status/939576907770793984',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513595898989-Screen_Shot_2017_12_14_at_12.11.19.png',
    },
    {
      platform: 'instagram',
      title: 'Instagram story 1 - 7th Dec',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601279507-IMG_0131.jpg',
      views: 53467
    },
    {
      platform: 'instagram',
      title: 'Instagram story 2 - 7th Dec',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601300427-IMG_0133.jpg',
      views: 66476
    },
    {
      platform: 'instagram',
      title: 'Instagram story 3 - 9th Dec',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601290424-IMG_0132.jpg',
      views: 80623
    },
    {
      platform: 'instagram',
      title: 'Jumanji cake',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1514042264986-WhatsApp_Image_2017_12_22_at_13.00.06.jpeg',
      views: 101741
    },
    {
      platform: 'instagram',
      title: 'Jumanji cake 2',
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1514042248599-WhatsApp_Image_2017_12_22_at_13.00.07.jpeg',
      views: 93879
    },
    {
      platform: 'snapchat',
      title: 'Snapchat 1 - 7th Dec',
      views: 83716,
    },
    {
      platform: 'snapchat',
      title: 'Snapchat 2 - 9th Dec',
      views: 85113,
    },
  ],
  networkActivity: [
    {
      platform: 'twitter',
      influencer: 'rvbberduck',
      followers: '8.2k',
      title: 'I wanna tell y\'all what we\'re shooting today because it\'s so fucking cool but issasecret',
      url: 'https://twitter.com/rvbberduck/status/934365570543255552',
      views: 5279,
      engagements: 265,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601159940-Screen_Shot_2017_12_14_at_12.10.45.jpeg',
    },
    {
      platform: 'twitter',
      influencer: 'Sarah Close',
      followers: '273k',
      title: 'i held a tarantula and python!!!!',
      url: 'https://twitter.com/Sazclose/status/934524496714838021',
      views: 101041,
      engagements: 4478,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601219481-Screenshot_20171128_171542.png',
    },
    {
      platform: 'twitter',
      influencer: 'Sarah Close',
      followers: '273k',
      title: 'Callum surprised me with something today which is honestly one of the coooooolest things that ive ever experienced',
      url: 'https://twitter.com/Sazclose/status/934510571499728898',
      views: 29967,
      engagements: 1422,
      screenshot: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/processed-1513601235900-Screenshot_20171128_171602.png',
    },

    {
      platform: 'twitter',
      influencer: 'George Benson',
      title: 'This was class Mate!',
      followers: '116k',
      url: 'https://twitter.com/MrGeorgeBenson/status/939997494167134208',
      views: 0,
      engagements: 0,
    },

    {
      platform: 'twitter',
      influencer: 'Ethan Payne',
      title: 'sick video x',
      followers: '1.2m',
      url: 'https://twitter.com/Behzinga/status/939589792597192704',
      views: 0,
      engagements: 0,
    },


  ],
  heroData: {
    main: {
      title: 'TURNING MY GIRLFRIEND\'S ROOM INTO A JUNGLE',
      subTitle: 'Do I get dumped at the end of this video or na? haha. Previews for Jumanji: Welcome To The Jungle are open this weekend, 9th & 10th December, book your tickets now! Catch it in UK cinemas from 20th December. Watch the trailer here: https://youtu.be/cKs-8ULhmbU',
      videoUrl: 'https://www.youtube.com/watch?v=QcPhHmQYYwE',
      views: 392582,
      engagements: 27676,
      watchTimeUKIre: 1060302,
      watchTimeTotal: 1840083,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [90.7, 9.3],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [9.7, 37.7, 28.4, 7.7, 5.2, 0.8, 1.2],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.4, 4.4, 1.8, 0.8, 0.7, 0.1, 0.1],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 1004495,
        views: 211003,
      },
      {
        name: 'United States',
        watchTime: 171822,
        views: 37154,
      },
      {
        name: 'Australia',
        watchTime: 95864,
        views: 18627,
      },
      {
        name: 'Ireland',
        watchTime: 55807,
        views: 12001,
      },
      {
        name: 'Netherlands',
        watchTime: 46862,
        views: 9803,
      },
    ],
    },
    supportingData: {
      labels: [
        'twitter',
        'instagram story',
        'snapchat story',
      ],
      datasets: [{
        data: [716689, 200566, 168829],
        backgroundColor: [
          dyzioPalette.blue,
          dyzioPalette.bgPink,
          dyzioPalette.bgAmber,

        ],
        borderColor: [
          dyzioPalette.bgBlue,
          dyzioPalette.pink,
          dyzioPalette.amber,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/callux-jumanji-2017.js